const page = {
	state: {
		options: [
			{
				value: "invoices",
				text: "Facture"
			},
			{
				value: "quotes",
				text: "Devis"
			}
		],
		type: "invoices"
	},
	mutations: {
		pageType(state, payload) {
			state.type = ["invoices", "quotes"].includes(payload) ? payload : "invoices";
		}
	}
};

export default page;
